import genReducer from "../core/reducer";
import types from "./types";
import initialState from "./initialState";

export const ACF_MODEL = "acf";

export default genReducer(types, initialState);
